var E = /* @__PURE__ */ ((r) => (r.ADMIN = "admin", r.GUEST = "guest", r.GUEST_USER = "guest_user", r.HOST = "host", r.PRODUCER = "producer", r.SESSION_OWNER = "session_owner", r.VIEWER = "viewer", r))(E || {});
export {
  E as Role
};
